import React from 'react';
import {
    BreakArchiveDateTimeToolTip,
    BreakAuthorNameToolTip,
    BreakMetaDescriptionToolTip,
    BreakPageTitleToolTip,
    BreakPermalinkToolTip,
    BreakPublishDateTimeToolTip,
    BreakShowFBCommentsToolTip,
    BreakSocialDescriptionToolTip,
    BreakTitleToolTip,
    CCPADataSharingToolTip
} from 'components/break/tooltips/general-tool-tips';
import { enUSmessage } from 'i18n/en-US.js';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { isNewLayout } from 'utils/break-utils';
import { isNoU } from "../../../../utils/DBUtils";

export default {
    key: "breakGeneralSection",
    props: {
        headerKey: 'editbreak.general.heading',
    },
    fields: [
        // Confirmed from CMS PDFS
        {
            type: 'text',
            name: 'permalink',
            required: true,
            props: {
                labelKey: 'editbreak.general.url',
                helpContent: <BreakPermalinkToolTip/>,
                helpHeader: 'Break URL name',
                validationRules: [
                    {
                        type: 'PermalinkFormat'
                    }
                ]
            }
        },
        {
            type: 'text',
            name: 'title',
            required: true,
            props: {
                labelKey: 'editbreak.general.title',
                helpContent: <BreakTitleToolTip/>,
                helpHeader: 'Break Title',
                placeholderKey: 'editbreak.general.title.placeholder',
                validationRules: []
            }
        },
        {
            type: 'text',
            name: 'pageTitle',
            required: true,
            props: {
                labelKey: 'editbreak.general.page_title',
                helpContent: <BreakPageTitleToolTip/>,
                helpHeader: 'Break SEO Title Tag',
                placeholderKey: 'editbreak.general.page_title.placeholder',
                maxLength: 60,
                validationRules: [
                    {
                        type: 'CharacterLimit',
                        params: {
                            limit: 60
                        }
                    }
                ]
            }
        },
        {
            type: 'textarea',
            name: 'description',
            required: true,
            props: {
                labelKey: 'editbreak.general.description',
                helpContent: '',
                helpHeader: '',
                maxLength: 200,
                validationRules: [
                    {
                        type: 'CharacterLimit',
                        params: {
                            limit: 200
                        }
                    }
                ]
            }
        },
        {
            type: 'textarea',
            name: 'metaDescription',
            required: true,
            props: {
                labelKey: 'editbreak.general.meta_description',
                helpContent: <BreakMetaDescriptionToolTip/>,
                helpHeader: 'Break Meta Description',
                maxLength: 200,
                validationRules: [
                    {
                        type: 'CharacterLimit',
                        params: {
                            limit: 200
                        }
                    }
                ]
            }
        },
        {
            type: 'textarea',
            name: 'socialDescription',
            required: true,
            linkedField: (formProxy) => ["description"],
            props: {
                labelKey: 'editbreak.general.social_description',
                helpContent: <BreakSocialDescriptionToolTip/>,
                helpHeader: 'Social Description',
                maxLength: 200,
                validationRules: [
                    {
                        type: 'CharacterLimit',
                        params: {
                            limit: 200
                        }
                    }
                ]
            }
        },
        {
            type: 'radio',
            name: 'layout',
            required: true,
            // showField: (proxy) => (!isNoU(proxy.currentResource.layout) && proxy.currentResource.layout !== 'CLASSIC_2018'),
            props: {
                labelKey: 'editbreak.general.layout',
                options: [
                  {
                    textKey: 'editbreak.general.layout.classic_2018',
                    value: 'CLASSIC_2018'
                  },
                  {
                    textKey: 'editbreak.general.layout.vertical_scroll',
                    value: 'VERTICAL_SCROLL'
                  }
                ]
            }
        },
          {
            type: 'radio',
            name: 'navigationType',
            required: false,
            showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored' && (isNewLayout(proxy.currentBaseResource))),
            props: {
                labelKey: 'Navigation',
                options: [
                    {
                        value: "LEFT",
                        textKey: 'Left nav'
                    },
                    {
                        value: "TOP",
                        textKey: 'Top nav'
                    },
                    {
                        value: "NONE",
                        textKey: 'No navigation'
                    }
                ]
            }
        },          
  
        // {
        //     type: 'radio',
        //     name: 'layout',
        //     required: true,
        //     // showField: (proxy) => (!isNoU(proxy.currentResource.layout) && proxy.currentResource.layout !== 'CLASSIC_2018'),
        //     props: {
        //         labelKey: 'editbreak.general.layout',
        //         options: [
        //           {
        //             textKey: 'editbreak.general.layout.classic_2018',
        //             value: 'CLASSIC_2018'
        //           },
        //           {
        //             textKey: 'editbreak.general.layout.vertical_scroll',
        //             value: 'VERTICAL_SCROLL'
        //           }
        //         ]
        //     }
        // },

        // {
        //     type: 'hardcodedText',
        //     key: "landing-screen-moved",
        //     showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'sponsored'),
        //     props: {
        //       text: 'Landing Screen settings have moved to their own section just above steps.',
        //     }
        // },

        {
          conditionalSection: true,
          name: "scheduleStartDate",
          required: true,

          props: {
              labelKey: 'editbreak.general.schedule_start_date',
              helpContent: <BreakPublishDateTimeToolTip/>,
              helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.schedule_start_date'}/></IntlProvider>
          },

          fields: [
            {
                type: 'datetime',
                name: 'startDate',
                required: true,
                requiredPlatforms: true,
                props: {
                    labelKey: 'editbreak.general.date.publish',
                    placeholderKey: 'editbreak.general.date.placeholder'
                }
            }
          ]
        },
        {
          conditionalSection: true,
          name: "archiveBreak",
          required: true,

          props: {
              labelKey: 'editbreak.general.archive_break',
              helpContent: <BreakArchiveDateTimeToolTip/>,
              helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.archive_break'}/></IntlProvider>
          },

          fields: [
            {
                type: 'datetime',
                name: 'endDate',
                required: true,
                requiredPlatforms: true,
                props: {
                    labelKey: 'editbreak.general.date.archive',
                    placeholderKey: 'editbreak.general.archive.placeholder'
                }
            }
          ]
        },
        {
            // TODO: Make custom component for viewing and selecting users (possibly prizes), to replace the valueProjection prop
            type: 'text',
            name: 'authorIds',
            idFor: 'authors',
            // showField: (proxy) => (isNoU(proxy.currentBaseResource.hubId)),
            showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'editorial'),
            props : {
                labelKey: 'editbreak.general.authorIds',
                helpContent: <BreakAuthorNameToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.authorIds'}/></IntlProvider>,
                asList: true,
                placeholderKey: "notAvailable",
                valueProjection: (value, {idAssetValue}) => {
                    if (isNoU(value)) {
                        return value;
                    }

                    let usernames = [];
                    // value should be an array of uuids
                    // and idAssetValue should be an array of authors
                    for (let id of value) {
                        let author = idAssetValue.find((item) => item.uuid === id);
                        // Reuse id if author is not in asset value
                        if (isNoU(author)) {
                            usernames.push(id);
                        } else {
                            usernames.push(author.username);
                        }
                    }

                    return usernames;
                }
            }
        },
        {
          type: 'yesnoradio',
          name: 'showFBComments',
          required: true,
          showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'editorial'),
          props:{
            labelKey: 'editbreak.general.facebookComments',
            helpContent: <BreakShowFBCommentsToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.facebookComments'}/></IntlProvider>
          }
        },
        {
            conditionalSection: true,
            name: "hasCustomCardEyebrowCopy",
            required: false,
            props: {
                labelKey: 'Show custom eyebrow copy on hero cards',
            },

            fields: [
              {
                // type: 'contenteditable',
                type: 'text',
                  name: 'customCardEyebrowCopy',
                  required: true,
              }
            ]
        },
    //   {
    //     conditionalSection: true,
    //     name: "hasHomePageTracking",
    //     required: true,
    //     props: {
    //       labelKey: 'editbreak.general.has_home_page_tracking',
    //       // helpContent: <BreakPixelToolTip/>,
    //       // helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.has_home_page_tracking'}/></IntlProvider>
    //     },

    //     fields: [
    //       {
    //         type: 'textarea',
    //         name: 'homePageTracking',
    //         required: true,

    //         props: {
    //           helpContent: <BreakPixelToolTip/>,
    //           helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.general.break_home_page_pixel_tracking'}/></IntlProvider>
    //         }
    //       }
    //     ]
    //   },
    //     {
    //     type: 'yesnoradio',
    //     name: 'exclusive',
    //     showField: (proxy) =>  (proxy.currentResource.sponsoredType !== 'sponsored' && isNoU(proxy.currentBaseResource.hubId)),
    //     required: true,
    //     props: {
    //       labelKey: 'editbreak.general.exclusive'
    //     }
    //   },
    //     {
    //         type: 'number',
    //         name: 'pointAward',
    //         showField: (proxy) => isBreakInHub(proxy.currentBaseResource), // Let permissions handle eventually,
    //         required: true,
    //         props: {
    //             labelKey: 'editbreak.general.pointAward',
    //             validationRules: [
    //                 {
    //                     type: 'InclusiveRange',
    //                     params: {
    //                         min: 1,
    //                         max: 5000
    //                     }
    //                 }
    //             ]
    //         }
    //     },
        {
            type: "textarea",
            name: "ccpaDataSharing",
            required: false,
            showField: (proxy) =>  (proxy.currentResource.sponsoredType === 'sponsored' || !isNoU(proxy.currentBaseResource.hubId)),
            props: {
                label: "CCPA Data Sharing Declaration",
                helpContent: <CCPADataSharingToolTip/>,
                placeholder: "Business Name\nMailing Address\nCity, State"
            }
        },
        {
            type: "text",
            name: "shareUrl",
            required: false,
            showField: (proxy) =>  (proxy.currentResource.sponsoredType === 'sponsored' && (isNewLayout(proxy.currentBaseResource))),
            props: {
                label: "Override Share URL",
                placeholder: "https://client.com/program"
            }
        },
    ]
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksGeneralSection.js